import { JobExecution } from '@lct-jobs/core';

export enum MassOperationType {
  MASS_JOB = 'massJob',
  MASS_QUERY = 'massQuery',
}

/**
 * Mass jobs and mass queries are both executed by the MassJobExecutor job, so jobId, jobName and
 * tenantType are identical for both. Only the stored input distinguishes them.
 */
interface MassOperationInput {
  massJob?: { jobId?: string };
  queryInfo?: { queryName?: string };
}

const massOperationInput = (execution?: JobExecution) =>
  execution?.jobInput as MassOperationInput | undefined;

export const getMassOperationType = (execution?: JobExecution): MassOperationType | undefined => {
  const input = massOperationInput(execution);
  if (input?.massJob) {
    return MassOperationType.MASS_JOB;
  }
  if (input?.queryInfo) {
    return MassOperationType.MASS_QUERY;
  }
  return undefined;
};

/** The child job id for a mass job, or the query name for a mass query. */
export const getMassOperationName = (execution?: JobExecution): string | undefined => {
  const input = massOperationInput(execution);
  return input?.massJob?.jobId ?? input?.queryInfo?.queryName;
};
